<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'ACTIVATION.ORDER_SUBMITTED.ORDER_SUBMITTED' | translate }}
    </glxy-page-title>
    <glxy-page-actions>
      @if (showShareFulfillmentFormSignal()) {
        <button mat-stroked-button (click)="openSendEmailDialog()" data-action="work-order-form-share-button">
          <mat-icon>person_add</mat-icon>
          {{ 'FULFILLMENT.SHARE' | translate }}
        </button>
      }
    </glxy-page-actions>
  </glxy-page-toolbar>
  <glxy-page-wrapper>
    <ng-container
      *ngIf="{
        salesOrder: salesOrder$ | async,
        users: users$ | async,
        accountDetailsUrl: accountDetailsUrl$ | async,
        salesOrderUrl: salesOrderUrl$ | async
      } as orderSubmittedData"
    >
      <orders-submitted
        #orderSubmittedComponent
        [users]="orderSubmittedData.users"
        [order]="orderSubmittedData.salesOrder"
        [salesOrderUrl]="orderSubmittedData.salesOrderUrl"
        [accountDetailsUrl]="orderSubmittedData.accountDetailsUrl"
        (showShareFulfillmentForm)="showShareFulfillmentForm($event)"
      ></orders-submitted>
    </ng-container>
  </glxy-page-wrapper>
</glxy-page>
